module.exports = __webpack_public_path__ + "media/sq_header_milovat_pohyb.3dad5474.mp4";